// ===========================================================================
// HealthStatusCohort — lista compacta de Health Status con su costo agregado.
// Responde: ¿qué grupo clínico priorizar?
// ===========================================================================
import React from "react";
import { Box, Paper, Typography, Stack } from "@mui/material";
import { formatCompactCurrency } from "../../utils/format";
import { HEALTH_STATUS_COLORS } from "../../common/constants";

export default function HealthStatusCohort({ data }) {
  const rows = Array.isArray(data) ? data : [];

  return (
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 3, height: "100%" }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.5 }}>
        By clinical cohort
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Health Status · aggregated cost
      </Typography>

      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          No data available yet.
        </Typography>
      ) : (
        <Stack spacing={1} sx={{ mt: 2 }}>
          {rows.map((row) => (
            <Stack
              key={row.healthStatus}
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ py: 0.5, borderBottom: "1px solid", borderColor: "divider" }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: HEALTH_STATUS_COLORS[row.healthStatus] || "#9e9e9e",
                  flexShrink: 0,
                }}
              />
              <Typography variant="body2" sx={{ flex: 1, fontWeight: 600 }}>
                {row.healthStatus}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {Number(row.patients || 0).toLocaleString()} pts
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 700, fontVariantNumeric: "tabular-nums", minWidth: 70, textAlign: "right" }}>
                {formatCompactCurrency(row.totalCost)}
              </Typography>
            </Stack>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
